// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.stato {
  margin-top: 7px;
  margin-bottom: 2px;
}

ion-content {
  margin-top: -20px !important;
  padding-top: -10px !important;
  padding-right: -5px !important;
  margin-right: -5px !important;
  padding-left: -5px !important;
  margin-left: -5px !important;
}

.allinea-presenti {
  margin-top: -1px !important;
  margin-bottom: 0px !important;
}

.icon-forward {
  margin: 5px;
}

/*
.label-md {
margin: 3px 8px 13px 0 !important;
}
*/
/*
* nota: colori scelti rispettando standard di leggibilità
* https://material.io/guidelines/style/color.html#color-color-tool
*/
.IN_CORSO {
  background-color: var(--sfondo_verde_accessibile);
  color: white;
  padding: 4px;
  padding-top: 2px;
  border-radius: 0px;
  font-size: 0.8rem;
  text-transform: none;
}

.IN_RITARDO {
  background-color: var(--sfondo_arancio_accessibile);
  color: white;
  padding: 4px;
  padding-top: 2px;
  border-radius: 0px;
  font-size: 0.8rem;
  text-transform: none;
}

.CONCLUSA {
  background-color: var(--sfondo_rosso_accessibile);
  color: white;
  padding: 4px;
  padding-top: 2px;
  border-radius: 0px;
  font-size: 0.8rem;
}

.IN_PROGRAMMA {
  background-color: var(--sfondo_grigio_accessibile);
  color: white;
  padding: 4px;
  padding-top: 2px;
  border-radius: 0px;
  font-size: 0.8rem;
}

.icon-geoloc {
  color: green;
  vertical-align: text-top;
}

.icon-dark {
  margin-left: 2px;
}

.titolo-white,
ion-item p.titolo-white {
  font-weight: 500;
  font-size: 1.2rem;
  color: #fff;
}

.titoletto,
ion-item p.titoletto {
  white-space: normal;
}

.text-data,
ion-item p.text-data {
  font-size: 1rem !important;
  color: var(--color-dark) !important;
  vertical-align: super;
}

.text-data-small,
ion-item p.text-data-small {
  font-size: 0.8rem !important;
  color: var(--color-dark) !important;
  vertical-align: super;
  overflow: visible;
}

.codice-rilevazione-white,
ion-item p.codice-rilevazione-white {
  font-weight: 500;
  font-size: 1.8rem;
  color: #fff;
  margin-top: 0px !important;
}

.icon-small-green {
  color: green;
}

.warningTime {
  color: white;
  background-color: var(--sfondo_arancio_accessibile);
  font-size: 0.9rem;
}

.impedisciVerifica {
  color: white;
  background-color: var(--sfondo_rosso_accessibile);
  font-size: 0.9rem;
}

.note {
  display: flex;
  justify-content: flex-end;
}

.titoloPta {
  margin-top: 0px;
  font-size: small;
}

ion-card-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
ion-card-header > ion-card-title, ion-card-header > .qrContainer {
  padding: 15px 15px 0;
}

ion-modal app-qrcode-viewer {
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ril-viewer/ril-viewer.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,eAAA;EACA,kBAAA;AAEJ;;AACE;EACE,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;AAEJ;;AACE;EACE,2BAAA;EACA,6BAAA;AAEJ;;AACE;EAEE,WAAA;AACJ;;AAEE;;;;CAAA;AAMA;;;CAAA;AAKA;EACE,iDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AADJ;;AAIE;EACE,mDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AADJ;;AAIE;EACE,iDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAIE;EACE,kDAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAIE;EACE,YAAA;EACA,wBAAA;AADJ;;AAIE;EACE,gBAAA;AADJ;;AAIE;;EAEE,gBAAA;EACA,iBAAA;EACA,WAAA;AADJ;;AAIE;;EAEE,mBAAA;AADJ;;AAKE;;EAEA,0BAAA;EACA,mCAAA;EACA,qBAAA;AAFF;;AAKE;;EAEA,4BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;AAFF;;AAKA;;EAEE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;AAFF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,mDAAA;EACA,iBAAA;AAJF;;AAOA;EACE,YAAA;EACA,iDAAA;EACA,iBAAA;AAJF;;AAOA;EACE,aAAA;EACA,yBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAKE;EACE,oBAAA;AAHJ;;AAOA;EACE,YAAA;EACA,WAAA;AAJF","sourcesContent":[".stato {\n    margin-top: 7px;\n    margin-bottom: 2px;\n  }\n  \n  ion-content {\n    margin-top: -20px !important;\n    padding-top: -10px !important;\n    padding-right: -5px !important;\n    margin-right: -5px !important;\n    padding-left: -5px !important;\n    margin-left: -5px !important;\n  }\n  \n  .allinea-presenti {\n    margin-top: -1px !important;\n    margin-bottom: 0px !important;\n  }\n  \n  .icon-forward {\n    // margin-top: -1px !important;\n    margin: 5px;\n  }\n\n  /*\n  .label-md {\n  margin: 3px 8px 13px 0 !important;\n  }\n  */\n  \n  /*\n  * nota: colori scelti rispettando standard di leggibilità\n  * https://material.io/guidelines/style/color.html#color-color-tool\n  */\n  \n  .IN_CORSO {\n    background-color: var(--sfondo_verde_accessibile);\n    color: white;\n    padding: 4px;\n    padding-top: 2px;\n    border-radius: 0px;\n    font-size: 0.8rem;\n    text-transform:none;\n  }\n  \n  .IN_RITARDO {\n    background-color: var(--sfondo_arancio_accessibile);\n    color: white;\n    padding: 4px;\n    padding-top: 2px;\n    border-radius: 0px;\n    font-size: 0.8rem;\n    text-transform:none;\n  }\n  \n  .CONCLUSA {\n    background-color: var(--sfondo_rosso_accessibile);\n    color: white;\n    padding: 4px;\n    padding-top: 2px;\n    border-radius: 0px;\n    font-size: 0.8rem;\n  }\n\n  .IN_PROGRAMMA {\n    background-color: var(--sfondo_grigio_accessibile);\n    color: white;\n    padding: 4px;\n    padding-top: 2px;\n    border-radius: 0px;\n    font-size: 0.8rem;\n  }\n  \n  .icon-geoloc {\n    color: green;\n    vertical-align: text-top;\n  }\n  \n  .icon-dark {\n    margin-left: 2px;\n  }\n\n  .titolo-white,\n  ion-item p.titolo-white {\n    font-weight: 500;\n    font-size: 1.2rem;\n    color: #fff;\n  }\n\n  .titoletto,\n  ion-item p.titoletto {\n    white-space: normal;\n  }\n\n \n  .text-data,\n  ion-item p.text-data {\n  font-size: 1rem !important;\n  color: var(--color-dark) !important;\n  vertical-align: super;\n  }\n\n  .text-data-small,\n  ion-item p.text-data-small {\n  font-size: 0.8rem !important;\n  color: var(--color-dark) !important;\n  vertical-align: super;\n  overflow: visible;\n  }\n\n.codice-rilevazione-white,\nion-item p.codice-rilevazione-white {\n  font-weight: 500;\n  font-size: 1.8rem;\n  color: #fff;\n  margin-top: 0px !important;\n  // margin-bottom: 5px !important;\n  // padding-bottom: 10px !important;\n}\n\n.icon-small-green {\n  color: green;\n}\n\n.warningTime {\n  color: white;\n  background-color: var(--sfondo_arancio_accessibile);\n  font-size: 0.9rem;\n}\n\n.impedisciVerifica {\n  color: white;\n  background-color: var(--sfondo_rosso_accessibile);\n  font-size: 0.9rem;\n}\n\n.note {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.titoloPta {\n  margin-top: 0px;\n  font-size: small;\n}\n\nion-card-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  > ion-card-title, > .qrContainer {\n    padding: 15px 15px 0;\n  }\n}\n\nion-modal app-qrcode-viewer {\n  height: 100%;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
